export const ADD_FEES_REQUEST = 'ADD_FEES_REQUEST'
export const ADD_FEES_SUCCESS = 'ADD_FEES_SUCCESS'
export const ADD_FEES_FALIURE = 'ADD_FEES_FALIURE'
